export default import.meta.ROLLDOWN_FILE_URL_BCe2x5GgrP0K$8pEzuQGZg